import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import { Image } from 'Components/Image';
import { Typography } from 'Components/Typography';

import { prosePromiseContent } from 'assets/content/homeV2';
import ticker from 'assets/images/ticker.svg';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 30px;
  background-color: ${theme.colors.primary[300]};
  color: ${theme.colors.neutral[100]};
  border-radius: ${theme.radius.xs};

  ${mediaMinWidth('md')} {
    justify-content: center;
    padding: ${theme.spacing['15x']};
  }
`;

const Title = styled(Typography)`
  font-size: 24px;

  ${mediaMinWidth('md')} {
    font-size: 36px;
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${theme.spacing['5x']};

  ${mediaMinWidth('sm')} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ${mediaMinWidth('md')} {
    justify-content: center;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex: 1;
`;

const ElementContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  ${mediaMinWidth('sm')} {
    width: calc(50% - 30px);
  }

  ${mediaMinWidth('md')} {
    width: calc(50% - ${theme.spacing['15x']});
  }
`;

const Element = styled(Typography)`
  width: 100%;
  padding-left: 8px;
  justify-content: center;
  align-items: center;
  ${mediaMinWidth('md')} {
    font-size: 16px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['5x']};
  justify-content: center;
  align-items: flex-start;

  ${mediaMinWidth('md')} {
    flex-direction: row;
    align-items: center;
  }
`;

export const ProsePromise = () => (
  <Wrapper data-testid="home-revamp-prose-promise">
    <TextWrapper>
      <TitleContainer>
        <Title variant="h2">{prosePromiseContent.title}</Title>
      </TitleContainer>
      <ListContainer>
        {prosePromiseContent.list.map((element) => (
          <ElementContainer key={element}>
            <div>
              <Image alt="Ticker logo" height={9} src={ticker} width={11} />
            </div>
            <Element variant="p2">{element}</Element>
          </ElementContainer>
        ))}
      </ListContainer>
    </TextWrapper>
  </Wrapper>
);
